/* eslint import/prefer-default-export: 0 */
import _ from 'lodash';
import * as t from './action_types';

const initialState = {
  flyoutAnimationIsOver: false,
  flyoutInformations: {},
  flyoutIsOpen: false,
  maintenanceMode: false,
  mobileHeaderVisibility: true,
  mobileMenuVisibility: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case t.OPEN_APP_FLYOUT: {
      return {
        ...state,
        flyoutIsOpen: true,
        flyoutInformations: _.get(action, 'payload', {}),
      };
    }
    case t.UPDATE_APP_FLYOUT: {
      return {
        ...state,
        flyoutInformations: _.get(action, 'payload', {}),
      };
    }
    case t.CLOSE_APP_FLYOUT: {
      return {
        ...state,
        flyoutIsOpen: false,
        flyoutInformations: {},
      };
    }
    case t.APP_FLYOUT_IS_OPENED: {
      return {
        ...state,
        flyoutAnimationIsOver: true,
      };
    }
    case t.APP_FLYOUT_IS_CLOSED: {
      return {
        ...state,
        flyoutAnimationIsOver: false,
      };
    }
    case t.MOBILE_HEADER_SET_VISIBILITY: {
      const { payload } = action;
      return {
        ...state,
        mobileHeaderVisibility: payload,
      };
    }
    case t.MOBILE_MENU_SET_VISIBILITY: {
      const { payload } = action;
      return {
        ...state,
        mobileMenuVisibility: payload,
      };
    }
    case t.START_MAINTENANCE_MODE: {
      return {
        ...state,
        maintenanceMode: true,
      };
    }
    case t.FINISH_MAINTENANCE_MODE: {
      return {
        ...state,
        maintenanceMode: false,
      };
    }
    default:
      return state;
  }
};
